/* eslint-disable @typescript-eslint/prefer-for-of */
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { IonContent, IonHeader } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';

import { Article } from '../../models/article.model';
import { ArticlesService } from '../../services/articles.service';
import { Oneperweek } from '../../services/oneperweek';
import { Logout } from '../../services/logout.provider';
import { MetaProvider } from '../../services/meta.provider';
import { Multitenant } from '../../services/multitenant.provider';
import { AuthProvider } from '../../services/auth.provider';
import { PopUp } from '../../models/popup.model';
import { GaEventTrackerProvider } from '../../services/gaeventtracker.provider';
import { PopUpService } from '../../shared/components/pop-up/pop-up.service';
import { combineLatest } from 'rxjs';
import { replaceWithNbspBeforeArray, sharedItems } from 'src/app/shared/utils';

@Component({
  selector: 'app-detail',
  templateUrl: 'detail.html',
  styleUrls: ['detail.scss']
})
export class DetailPage implements OnInit {
  @ViewChild(IonContent) content: IonContent;
  @ViewChild(IonHeader) header: IonHeader;

  public article: Article;
  public articles: Article;
  public isClassVisible: boolean;
  public isContextVisible: boolean;
  public isClassLearn: boolean;
  public isClassKey: boolean;
  public isClassQuestion: boolean;
  public isClassEarth: boolean;
  public error: string;
  public pressAnswer = new Object();
  public isClassLearnChild = new Object();
  public isActivePage: string;
  public tempPopUp: boolean;
  public popup: PopUp = new PopUp();
  public locale: string;
  public ua: string;
  public sabSession: boolean;
  public sab: boolean;
  public hideVideoOverlay: boolean;
  private slug: string;
  private isFree: boolean;
  private pass: boolean;
  private one: any;
  public category: string;
  public currentPosition = window.scrollY;

  constructor(
    public oneperweek: Oneperweek,
    private actRoute: ActivatedRoute,
    private router: Router,
    private articlesService: ArticlesService,
    private logout: Logout,
    private meta: MetaProvider,
    protected multiTenant: Multitenant,
    private auth: AuthProvider,
    private ga: GaEventTrackerProvider,
    private popUpService: PopUpService,
    public renderer: Renderer2
  ) { }

  ngOnInit(): void {
    combineLatest([this.actRoute.params, this.actRoute.queryParams])
    .subscribe(([params, queryParams]) => {
        this.isClassVisible = false;
        this.isContextVisible = false;
        this.isClassLearn = false;
        this.isClassKey = false;
        this.isClassQuestion = false;
        this.isClassEarth = false;
        this.one = this.oneperweek;
        this.hideVideoOverlay = true;
        this.slug = params.slug;
        this.category = queryParams.category;

        this.getArticleDetail();
    });
  }

  ionViewWillEnter() {
    if (this.multiTenant.getDomainClass() === 'mwjp') {
      this.locale = 'ja';
    } else if (
      this.multiTenant.getDomainClass() === 'week' ||
      this.multiTenant.getDomainClass() === 'mlwk'
    ) {
      this.locale = 'en';
    } else if (this.multiTenant.getDomainClass() === 'sema') {
      this.locale = 'es';
    } else if (this.multiTenant.getDomainClass() === 'woch') {
      this.locale = 'de';
    } else {
      this.locale = 'fr';
    }
    this.ua = this.getUserUa();
    this.sabSession = sessionStorage.getItem('sab') === 'closed' ? true : false;
    this.renderer.setStyle(this.header['el'], 'webkitTransition', 'margin-top 700ms');
  }

  ionViewDidEnter() {
    this.meta.clearHead();
    const timeframe = document.getElementsByTagName('iframe');
    if (timeframe.length > 0) {
      for (let i = 0; i < timeframe.length; i++) {
        timeframe[i].width = '100%';
      }
    }

    if (!this.auth.isAuthenticated() && this.popUpService.havePassedSevenDays() && this.multiTenant.getDomainClass() === 'playbacpresse') {
      this.tempPopUp = true;
      this.popup.type = 'unIdentifiedUser';
    }
  }

  getArticleDetail() {
    return this.articlesService.getArticleDetailService(this.slug, this.category).subscribe({
      next:(response) => {
        if (response[0]) {
          replaceWithNbspBeforeArray.forEach(
            el => {
              const escapedTarget = el.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
              const regex = new RegExp(`\\s+${escapedTarget}`, 'g');
              response[0].article_title = response[0].article_title.replace(regex, '&nbsp' + el);
              response[0].article_subtitle = response[0].article_subtitle ? response[0].article_subtitle.replace(regex, '&nbsp' + el) : undefined;
              response[0].article_subhead = response[0].article_subhead ? response[0].article_subhead.replace(regex, '&nbsp' + el) : undefined;
              response[0].article_content = response[0].article_content ? response[0].article_content.replace(regex, '&nbsp' + el) : undefined;
              response[0].article_editor_sentence = response[0].article_editor_sentence ? response[0].article_editor_sentence.replace(regex, '&nbsp' + el) : undefined;
              response[0].article_context = response[0].article_context ? response[0].article_context.replace(regex, '&nbsp' + el) : undefined;
              response[0].article_side_content = response[0].article_side_content ? response[0].article_side_content.replace(regex, '&nbsp' + el) : undefined;
            }
          );
        }

        this.one.checkOnePerWeek( response[0].article_id, response[0].newspaper_subname, response[0].is_excluded_from_paywall);
        this.meta.addDescription(response[0].article_content && response[0].article_content.length > 0 ? response[0].article_content.replace(/<[^>]*>?/gm, '').substring(0, 920) : response[0].article_title);
        this.pass = this.one.pass;
        this.isFree = response[0].is_free;
        if (response[0].favorite) {
          this.isFree = true;
        }
        if (!this.pass && !this.isFree) {
          const newspaperName = response[0].newspaper_subname == 'acne' ? 'L\'ACTU' : response[0].newspaper_name;
          this.router.navigate([''], { queryParams: { tempPopUp: true, isExcludedFromPaywall: response[0].is_excluded_from_paywall, newspaper: newspaperName } });
        } else {
          if (!this.checkKeywordsExist(response[0].article_content)) {
            this.article = this.articleKeywords(response[0]);
            this.article.publish_on_Obj = this.formatDatePublish( this.article.publish_on );
          } else {
            this.article = response[0];
            this.article.publish_on_Obj = this.formatDatePublish( this.article.publish_on );
          }
          if (this.article.hasOwnProperty('children')) {
            for (let i = 0; i < this.article.children.length; i++) {
              this.article.children[i] = this.articleKeywords( this.article.children[i] );
              if (
                this.article.children[i].hasOwnProperty('article_questions')
              ) {
                if (this.article.hasOwnProperty('article_questions')) {
                  this.article.article_questions = this.article.article_questions.concat( this.article.children[i].article_questions );
                } else {
                  this.article.article_questions = this.article.children[0].article_questions;
                }
                if ( this.article.children[i].hasOwnProperty('article_keywords') ) {
                  if (this.article.hasOwnProperty('article_keywords')) {
                    this.article.article_keywords = this.article.article_keywords.concat( this.article.children[i].article_keywords );
                  } else {
                    this.article.article_keywords = this.article.children[i].article_keywords;
                  }
                }
              }
            }
          }
          if (this.article.carrousel) {
            const carrousel = this.article.carrousel;
            let newCopy: string;
            carrousel.forEach( (item) => {
              if (item.image_copyright) {
                const copy = item.image_copyright;
                if (copy.search('©') >= 0) {
                  newCopy = copy.replace('©', '');
                }
                item.image_copyright = newCopy;
              }
            });
          }

          if (this.article.newspaper_name === 'A19') {
            this.article.image_description = this.article.image_description.replace('<b>PHOTO DU JOUR :</b>', '');
          //   article.article_content = article.article_content.replace(/<b>Contexte.<\/b>(?!<br>)/, '<b>Contexte.</b><br>');
          //   article.article_content = article.article_content.replace(/<strong>Contexte.<\/strong>(?!<br>)/, '<b>Contexte.</b><br>');
          //   article.article_content = article.article_content.replace(/<b>Réponse.<\/b>(?!<br>)/, '<b>Réponse.</b><br>');
          //   article.article_content = article.article_content.replace(/<strong>Réponse.<\/strong>(?!<br>)/, '<b>Réponse.</b><br>');
          }
        }
      },
      error:(error) => {
        if (error.message === 'Invalid tokens.') {
          this.logout.logOut();
          this.router.navigate(['connexion']);
        }
        this.error = ' Vos identifiants ne sont pas reconnus';
      }
    });
  }

  public onContentScroll(event:any) {
    let scroll = event.detail.scrollTop;
    if (scroll > 10 && scroll > this.currentPosition) {
      this.renderer.setStyle(this.header['el'], 'margin-top', '-51px');
    } else {
      this.renderer.setStyle(this.header['el'], 'margin-top', '0px');
    }

    this.currentPosition = scroll;
  }

  articleKeywords(article: Article) {
    if (article.article_keywords && article.article_keywords.length) {
      article.article_keywords.forEach((keyword) => {
        const regEx = new RegExp(`(${keyword.mot})`, 'ig');
        const replaceMask = `<a class="article_keyword" href="#mots" (click)="isClassKey = !isClassKey;" name="${keyword.mot}">$1</a>`;
        article.article_content = article.article_content.replace( regEx, replaceMask );
      });
    }
    return article;
  }
  onNotifyPopUp(message: string): void {
    this.tempPopUp = false;
  }
  headerNotify(message: string): void {
    this.tempPopUp = true;
    this.popup.type = 'featureToCome';
  }
  onBottomMenuNotify(message: any): void {
    this.tempPopUp = true;
    this.popup.type = 'featureToCome';
  }

  hexToRgba(hex: string = '#FFFFFF', opacity: number = 1): string {
    if (!hex) {
      return 'rgba(255, 255, 255, 0)';
    }
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return `rgba(${parseInt(result[1], 16)},${parseInt( result[2], 16 )},${parseInt(result[3], 16)},${opacity})`;
  }

  checkKeywordsExist(s: string) {
    const regEx = new RegExp(/(<a(.*?)(class="article_keyword")(.*?))>/);
    return regEx.test(s);
  }

  formatDatePublish(dateString: string): Date {
    const dateParts = dateString.split('/');
    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;
    let year = parseInt(dateParts[2], 10);
    if (year > 70) {
      year += 1900;
    } else {
      year += 2000;
    }
    return new Date(year, month, day);
  }

  getInclude() {
    if ( !this.auth.isAuthenticated() || (this.auth.isAuthenticated() && this.auth.getActiveProfile() === 'Children') ) {
      if (this.article) {
        return sharedItems(this.article.newspaper_subname);
      }
    } else {
      return ['facebook', 'twitter', 'email', 'whatsapp'];
    }
  }

  getUserUa() {
    const ua = window.navigator.userAgent;
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    const webkit = !!ua.match(/WebKit/i);
    const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    const isAndroid = !iOSSafari && navigator.userAgent.match(/android/i) != null;

    return isAndroid ? 'android' : 'ios';
  }

  hideSAB() {
    this.sab = true;
  }

  hiddenVideoOverlay() {
    if (this.article.newspaper_subname === 'play') {
      this.ga.trackEvent( 'Leçons de dessin', 'Play', this.article.article_title, null );
    }
    this.hideVideoOverlay = false;
    setTimeout( () => {
      const timeframe = document.getElementsByTagName('iframe');
      if (timeframe.length > 0) {
        for (let i = 0; i < timeframe.length; i++) {
          timeframe[i].width = '100%';
        }
      }
    }, 1000);
  }

  trackContentFrigobloc() {
    if (this.article.newspaper_subname === 'frigobloc') {
      this.ga.trackEvent( this.multiTenant.getDomainClass, 'Clic', 'Frigobloc', null );
    }
    this.hideVideoOverlay = false;
  }
}
